export const USER_DATA_SUCCESS = 'appsync/SETTINGS/SUCCESS';
export const USER_DATA_FAIL = 'appsync/SETTINGS/FAIL';

export default {
  USER_DATA_SUCCESS,
  USER_DATA_FAIL,
};
